import { b } from "@/b";
import { BoxProps, Grid, ResponsiveValue } from "@chakra-ui/react";
import { FragmentData } from "@gqlb/core";
import React, { useMemo } from "react";
import { ProductCard, ProductCard_Fragment } from "../product/ProductCard";

export const ProductMenuGrid_Fragment = b.fragment(
  "ProductGrid_Data",
  "Menu",
  (b) => [
    //
    b.products((b) => [
      b.product((b) => [
        b.__fragment(ProductCard_Fragment),
        b.tags((b) => [
          //
          b.id(),
          b.name(),
        ]),
      ]),
      b.callout(),
    ]),
    b.tags((b) => [
      //
      b.id(),
      b.name(),
    ]),
  ]
);

export const ProductGrid: React.FC<{
  data: FragmentData<typeof ProductMenuGrid_Fragment>;
  tagIdFilter: string[];
  cardHeight?: BoxProps["height"];
}> = ({ data, tagIdFilter, cardHeight }) => {
  const filteredProducts = useMemo(() => {
    if (tagIdFilter.length === 0) {
      return data.products;
    }
    return data.products.filter((p) => {
      return p.product.tags.some((t) => tagIdFilter.includes(t.id));
    });
  }, [data, tagIdFilter]);
  return (
    <Grid
      templateColumns={{
        lg: "repeat(auto-fill, minmax(300px, 1fr))",
        base: "1fr 1fr",
      }}
      gap="8"
    >
      {filteredProducts.map((p) => {
        return (
          <ProductCard
            key={p.product.id}
            data={p.product}
            height={cardHeight}
            callout={p.callout ?? undefined}
          />
        );
      })}
    </Grid>
  );
};
